var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c("WidgetUser"),
          _c(
            "v-flex",
            { staticClass: "sm12 md12 modulo-capacitaciones" },
            _vm._l(_vm.data, function(item) {
              return _c(
                "div",
                { key: item.idcategoria, staticClass: "capacitaciones__btn" },
                [
                  _c(
                    "v-btn",
                    {
                      class:
                        _vm.activeBtn == Number(item.idcategoria) &&
                        "btn--activate",
                      on: {
                        click: function($event) {
                          return _vm.showModal(item.idcategoria)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(item.categoria))])]
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm.dialog
            ? _c("ModalCapacitaciones", {
                attrs: { categoria: _vm.categoria, items: _vm.items }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }